import {type TextButtonProps as MfButtonProps} from 'modern-famly';
import type React from 'react';

import {type NonEmptyArray} from 'web-app/util/non-empty-array';

import {type ButtonAppearance} from '../components/button-v2';

export interface PartialDialogProps {
    image?: string;
    title: string;
    description?: React.ReactNode;
    okText?: string;
    cancelText?: string;
    children?: React.ReactNode;
    hideCancelButton?: boolean;
    hideSubmitButton?: boolean;
    className?: string;
    type?: 'mf';
    onDialogChoice?: (choice: DialogChoice) => void;
    ['data-e2e-id']?: string;
}

type DeprecatedDialogChoices<T> = {
    type?: never;
    choices: NonEmptyArray<DialogButton<T>>;
};

type MfDialogChoices<T> = {
    type: 'mf';
    choices: NonEmptyArray<MfDialogButton<T>>;
};

type DialogChoicesBase<T> = {
    title: string;
    description?: React.ReactNode;
    resolve: (value: T) => void;
    children?: React.ReactNode;
    className?: string;
    onDialogChoice?: (choice: DialogChoice) => void;
};

export type DialogProps<T> =
    | (DialogChoicesBase<T> & DeprecatedDialogChoices<T>)
    | (DialogChoicesBase<T> & MfDialogChoices<T>);

export type OnPredicatesDialogProps = PartialDialogProps & {
    predicate?: boolean;
} & (
        | {
              func: (...args: unknown[]) => void;
          }
        | {
              onPredicateFalseFunc: (...args: unknown[]) => void;
              onPredicateTrueFunc: (...args: unknown[]) => void;
          }
    );

export enum DialogChoice {
    OK = 1,
    CANCEL = 0,
}

export enum DialogType {
    CONFIRM,
    DELETE,
}

export interface DialogButton<T> {
    appearance: ButtonAppearance;
    text?: string;
    value: T;
    e2eId?: string;
}

export type MfDialogButton<T> = Pick<MfButtonProps, 'text' | 'variant' | 'size'> & {
    e2eId?: string;
    value: T;
};
